import { FC } from 'react';
import Project from '~/data/strapi/types/collection-types/project';

import ProjectDescriptionCards from './cards';
import ProjectDescriptionImage from './image';
import styles from './styles.module.css';

interface Props {
  project: Project;
  onNext?: () => void;
  onPrev?: () => void;
  hrefNext?: string;
  hrefPrev?: string;
  hideNavigation?: boolean;
}

const ProjectDescription: FC<Props> = ({ project, onNext, onPrev, hrefNext, hrefPrev, hideNavigation }) => {
  const image = project.image;

  return (
    <div className={styles.slideDescription}>
      {image && (
        <ProjectDescriptionImage
          image={image}
          onNext={onNext}
          onPrev={onPrev}
          hrefNext={hrefNext}
          hrefPrev={hrefPrev}
          hideNavigation={hideNavigation}
        />
      )}
      <ProjectDescriptionCards project={project} />
    </div>
  );
};

export default ProjectDescription;
